import { Flex, HStack, Stack, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

import { BankingSettings } from './BankingSettings';
import { CompanySettings } from './CompanySettings';
import { PasswordChange } from './PasswordChange';
import { ProfileView } from './ProfileView';
import React from 'react';
import { TermsAndConditionsEditor } from './TermsAndConditionsEditor';
import { ToastContainer } from 'react-toastify';

export const ViewSettings = () => {
    return (
        <>
            <Flex
                minH={'-webkit-fill-available'}
                justify={'center'}
                py={10}
                maxW={'4xl'}
                mx={'auto'}
            >
                <HStack w={['100%', '100%', '100%', '100%']}>
                    <Stack w={['100%']}>
                        <Tabs colorScheme={'yellow'}>
                            <TabList minW={'200px'}>
                                <Tab>Profile</Tab>
                                <Tab>Company</Tab>
                                <Tab>Billing</Tab>
                                <Tab>Security</Tab>
                                <Tab>Terms and Conditions</Tab>
                            </TabList>

                            <TabPanels>
                                <TabPanel w={'full'}>
                                    <ProfileView/>
                                </TabPanel>
                                <TabPanel>
                                    <CompanySettings/>
                                </TabPanel>
                                <TabPanel>
                                    <BankingSettings/>
                                </TabPanel>
                                <TabPanel>
                                    <PasswordChange/>
                                </TabPanel>
                                <TabPanel>
                                    <TermsAndConditionsEditor />
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </Stack>
                </HStack>
                <ToastContainer />
            </Flex>
        </>
    );
};